<template>
  <a-modal
    title="房间拆分"
    :visible="visible"
    :confirmLoading="submitting"
    destroyOnClose
    okText="提交"
    cancelText="取消"
    width="800px"
    :maskClosable="false"
    @ok="handleSubmit"
    @cancel="$emit('update:visible', false)"
  >
    <a-spin :spinning="loading" class="item-content">
        <a-row>
          <a-col :span="8">
            楼宇: &nbsp;&nbsp;{{current && current.buildingCode}}
          </a-col>
          <a-col :span="8">
            所属楼层:&nbsp;&nbsp;{{current && current.unitCode}}
          </a-col>
          <a-col :span="8">
            房间号:&nbsp;&nbsp;{{current && current.houseCode}}
          </a-col>
          <a-col :span="8">
            是否自用房:&nbsp;&nbsp;
            <span v-if="current && Boolean(current.selfFlag)">是</span>
            <span v-else>否</span>
          </a-col>
          <a-col :span="8">
            房间状态:&nbsp;&nbsp;
            <span v-if="current && Boolean(current.selfFlag)">自用</span>
            <span v-else-if="current && current.state==='0'">空置</span>
            <span v-else>已租</span>
          </a-col>
          <a-col :span="8">
            建筑面积:&nbsp;&nbsp;{{current && current.structureArea}}㎡
          </a-col>
          <a-col :span="24">
            备注:&nbsp;&nbsp;{{current && current.remark}}
          </a-col>
        </a-row>
          <div>
            <base-sub-title :title="houseName"/>
              <a-button slot="btns" type="primary" @click="handleAdd">新建</a-button>
            <a-table
              :rowKey="record => record.id"
              :scroll="{ y: 240 }"
              :pagination="false"
              :dataSource="dataSource"
              :columns="columns">
              <template slot="houseCode" slot-scope="_ ,record, index">
                <a-input
                  v-model="record.houseCode"
                  placeholder="请输入房间号"
                  @change="e => handleChange(e.target.value, index, 'houseCode')"
                />
              </template>
              <template slot="structureArea" slot-scope="_ ,record, index">
                <a-input-number :min="0"
                  v-model="record.structureArea"
                  placeholder="请输入建筑面积"
                  @change="e => handleChange(record.structureArea, index, 'structureArea')"
                />
              </template>
              <template slot="selfFlag" slot-scope="_ ,record, index">
                <a-switch
                  v-model="record.selfFlag"
                  placeholder="请输入是否自用"
                  @change="e => handleChange(record.selfFlag, index, 'selfFlag')"
                />
              </template>
              <template slot="seqNum" slot-scope="_ ,record, index">
                <a-input-number :min="0"
                  v-model="record.seqNum"
                  placeholder="请输入排序号"
                  @change="e => handleChange(record.seqNum, index, 'seqNum')"
                />
              </template>
              <template slot="remark" slot-scope="_ ,record, index">
                <a-input
                  v-model="record.remark"
                  placeholder="请输入备注"
                  @change="e => handleChange(e.target.value, index, 'remark')"
                />
              </template>
              <template slot="operation" slot-scope="_ ,__, index" >
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除?"
                  @confirm="() => handleDelete(index)"
                >
                  <a href="javascript: void 0;" class="text-btn" >删除</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>
    </a-spin>
  </a-modal>
</template>

<script>
import { investment } from '@/api'
import { trimNormalizer } from '@/utils/tools'
// import pick from 'lodash/pick'
export default {
  name: 'DialogRoomSplit',

  props: {
    visible: Boolean,
    current: Object
  },

  beforeCreate () {
    this.formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 15 }
    }
  },
  watch: {
    async visible (val) {
      if (!val) { return }
      await this.$nextTick()
      this.houseName = '房间拆分成   ' + this.current.buildingCode + '-' + this.current.unitCode
      // this.form.setFieldsValue(pick(this.current, ['buildingCode', 'unitCode', 'state', 'houseCode', 'structureArea', 'selfFlag', 'seqNum', 'remark']))
      this.dataSource = [{
        id: 0,
        houseCode: '',
        structureArea: '',
        selfFlag: false,
        seqNum: '',
        remark: ''
      },
      {
        id: 1,
        houseCode: '',
        structureArea: '',
        selfFlag: false,
        seqNum: '',
        remark: ''
      }]
    }
  },

  data () {
    return {
      loading: false,
      submitting: false,
      houseName: '',
      trimNormalizer,
      form: this.$form.createForm(this),
      formItemConfig: {
        validateFirst: true,
        normalize: trimNormalizer,
        rules: [{
          required: true,
          message: '请输入'
        }, {
          max: 32,
          message: '请输入少于32个字符'
        }]
      },
      dataSource: [
        {
          id: 0,
          houseCode: '',
          structureArea: '',
          selfFlag: false,
          seqNum: '',
          remark: ''
        },
        {
          id: 1,
          houseCode: '',
          structureArea: '',
          selfFlag: false,
          seqNum: '',
          remark: ''
        }
      ],
      columns: [
        {
          title: '房间号',
          dataIndex: 'houseCode',
          scopedSlots: { customRender: 'houseCode' }
        },
        {
          title: '建筑面积',
          dataIndex: 'structureArea',
          scopedSlots: { customRender: 'structureArea' }
        },
        {
          title: '是否自用',
          dataIndex: 'selfFlag',
          scopedSlots: { customRender: 'selfFlag' }
        },
        {
          title: '排序号',
          dataIndex: 'seqNum',
          scopedSlots: { customRender: 'seqNum' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 60,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },

  methods: {
    handleSubmit () {
      if (this.loading) return
      this.form.validateFields(async (err, values) => {
        if (err) return
        if (this.dataSource.length <= 1) {
          this.$message.info('至少要填写两个房间信息')
          return
        }
        let structureArea = 0
        let houseCodes = []
        for (let table of this.dataSource) {
          if (!table.houseCode) {
            this.$message.info('请填写房间号')
            return
          }
          if (!table.structureArea) {
            this.$message.info('请填写建筑面积')
            return
          }
          structureArea = structureArea + table.structureArea
          houseCodes.push(table.houseCode)
        }
        if (this.isRepeat(houseCodes)) {
          this.$message.warn('填写的房间号存在重复,请修改!')
          return
        }
        if (structureArea !== this.current.structureArea) {
          this.$message.warn('拆分成的房间面积之和必须要与拆分房间面积相同!')
          return
        }
        let payload = {
          houseId: this.current.houseId,
          treeCode: this.current.treeCode.substring(0, 20),
          newHouses: this.dataSource
        }
        this.submitting = true
        let { code, msg } = await investment.splitEstateHouse(payload)
        this.submitting = false
        if (code !== 0) return this.$message.error(msg || '拆分房间失败')
        this.$message.success('拆分成功!')
        this.$emit('update:visible', false)
        this.$emit('submitted')
      })
    },
    isRepeat (arr) {
      let nary = arr.sort()
      for (let i = 0; i < arr.length; i++) {
        if (nary[i] === nary[i + 1]) {
          return true
        }
      }
      return false
    },
    handleAdd () {
      this.dataSource.unshift({
        houseCode: '',
        structureArea: '',
        selfFlag: false,
        seqNum: '',
        remark: ''
      })
      this.dataSource.map((x, index) => { x.id = index })
    },
    handleDelete (index) {
      this.dataSource.splice(index, 1)
    },
    handleChange (val, index, field) {
      this.dataSource[index][field] = val
    }
  }
}
</script>

<style lang="less" scoped>
  .item-content {
    width: 100%;
    min-height: 120px;
    background-color: #fff;
    .ant-row {
      padding: 6px 0;
      line-height: 32px;
      color: #666;
    }
  }
</style>
